/** Unwrap a comment mark span, keeping its children in the document. */
export function unwrapCommentMarkSpan(span) {
  const parent = span.parentNode;
  if (!parent) return;
  while (span.firstChild) {
    parent.insertBefore(span.firstChild, span);
  }
  parent.removeChild(span);
}

/**
 * Wrap current selection in a stable span so the comment anchors in saved HTML (Word-style).
 * Must stay within a single contenteditable block; crossing blocks throws.
 */
export function wrapSelectionWithCommentMark(editorRootEl, commentId) {
  const sel = window.getSelection();
  if (!sel || sel.rangeCount === 0) {
    return { ok: false, error: 'No selection' };
  }
  const range = sel.getRangeAt(0);
  if (range.collapsed) {
    return { ok: false, error: 'No selection' };
  }
  if (!editorRootEl || !editorRootEl.contains(range.commonAncestorContainer)) {
    return { ok: false, error: 'Selection is outside the editor' };
  }

  try {
    const span = document.createElement('span');
    span.className = 'doc-inline-comment-mark';
    span.setAttribute('data-doc-comment-id', commentId);
    span.appendChild(range.extractContents());
    range.insertNode(span);

    sel.removeAllRanges();
    const newRange = document.createRange();
    newRange.selectNodeContents(span);
    newRange.collapse(false);
    sel.addRange(newRange);

    return { ok: true };
  } catch (e) {
    console.warn('wrapSelectionWithCommentMark:', e);
    return {
      ok: false,
      error:
        'Comment must be inside a single paragraph or heading (cannot cross block boundaries).',
    };
  }
}
